import { useMutation, useQueryClient } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { REPLY_SUGGESTIONS_PATH } from 'src/services/api/messages/use-reply-suggestions';

export enum EReplySuggestionStatus {
    SELECTED = 'selected',
    REJECTED = 'rejected',
}

type Request = {
    status: EReplySuggestionStatus;
    reply_message_uuid?: string | null;
};

/** Record the agent's decision on a suggestion: selected (inserted) or rejected. */
export const useUpdateReplySuggestion = () => {
    const queryClient = useQueryClient();

    return useMutation<void, unknown, { id: number } & Request>(
        async ({ id, ...payload }) => {
            await apiClient(`${REPLY_SUGGESTIONS_PATH}/${id}`, {
                method: 'patch',
                json: payload,
            });
        },
        {
            // Refetch so a decided (selected/rejected) suggestion drops server-side and
            // does not re-appear on a later refetch/remount.
            onSuccess: () => queryClient.invalidateQueries([queryKeys.replySuggestions]),
        }
    );
};
